import config from 'config';

import { ProductTag } from '../constants/products';

import { convertStringsToInts } from './convertStringsToInts';

export function isForcedSoldOut(
  product,
  isVip,
  isFemale,
  isAssortmentTestProductDisabled
) {
  const tagIdSet = new Set(convertStringsToInts(product.tagIdList));
  if (isAssortmentTestProductDisabled) {
    return true;
  }
  const soldOutForcedCheck = config.get(
    'public.brand.features.soldOutForcedCheck'
  );
  if (soldOutForcedCheck) {
    if (tagIdSet.has(ProductTag.fakeSoldOut)) {
      return true;
    }

    if (isVip && tagIdSet.has(ProductTag.soldOutVip)) {
      return true;
    }

    if (!isVip && tagIdSet.has(ProductTag.soldOutLead)) {
      return true;
    }

    return false;
  }

  return (
    (tagIdSet.has(ProductTag.fakeSoldOut) && isVip) ||
    (tagIdSet.has(ProductTag.fakeSoldOutMens) && isFemale && isVip)
  );
}
